module.exports = __webpack_public_path__ + "img/timer.dd441479.svg";